import { DetailsListLayoutMode } from "@fluentui/react"
import { IHistoricoEquipoDTO } from "../../../../../Interfaces/estadoEquipos/IEstadoEquipo"
import { TableBaseComponent } from "../../../../../components/Table/TableBaseComponent"
import { HeaderTablaDetail } from "../../../../../components/generic/HeaderTablaDetail"
import { IPaginationV2 } from "../../../../../Interfaces/base/ITable"
import { useState } from "react"
  
interface IHistoricoEquipoTabla {
    items: IHistoricoEquipoDTO[]
    loading: boolean,
    pagination?: IPaginationV2
    onChangeTake?: (size: number) => void; 
}
export const HistoricoEquipoTabla = (props: IHistoricoEquipoTabla) => {

    const onChangeTake = (size: number) => {
        // console.log(size);
      };

    const _columns = [
        {
            key: "hora",
            name: "Hora",
            fieldName: "hora",
            minWidth: 100,
            maxWidth: 100,
        },
        {
            key: "estado",
            name: "Estado",
            fieldName: "estado",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            key: "codigo",
            name: "Codigo",
            fieldName: "codigo",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            key: "razon",
            name: "Razón",
            fieldName: "razon",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            key: "operador",
            name: "Operador",
            fieldName: "operador",
            minWidth: 200,
            maxWidth: 200,
        },
        {
            key: "comentario",
            name: "Comentario",
            fieldName: "comentario",
            minWidth: 150,
            maxWidth: 150,
        },
        {
            key: "ubicacion",
            name: "Ubicación",
            fieldName: "ubicacion",
            minWidth: 150,
            maxWidth: 150,
        },
        {
            key: "combustible",
            name: "Combustible",
            fieldName: "combustible",
            minWidth: 100,
            maxWidth: 100,
        },
        {
            key: "horas",
            name: "Horas",
            fieldName: "horas",
            minWidth: 100,
            maxWidth: 300,
        },
    ]
    return (
        <div style={{ padding: '0px 10px' }}>
            <HeaderTablaDetail
                title={"Estados"}
                subTitle="Histórico de Estados"
                 />
            <br />
            <TableBaseComponent
                rigthBar={[]}
                data={props.items}
                column={_columns}
                isLoading={props.loading}
                getPageSize={onChangeTake}
                pagination={props.pagination}
                layout={DetailsListLayoutMode.justified}
            />
        </div>
    )

}